module.exports = __webpack_public_path__ + "img/overview3.6329b427.png";